export class UIAdElements {
    readonly containerMainPageRightTop: HTMLDivElement | null
    readonly containerMainPageRightMiddle: HTMLDivElement | null
    readonly containerMainPageRightBottom: HTMLDivElement | null
    readonly containerGameLeft: HTMLDivElement
    readonly containerGameRight: HTMLDivElement
    readonly containerGameBottom: HTMLDivElement
    readonly containerGameBottomSmall: HTMLDivElement
    readonly modeSelectorAd: HTMLDivElement | null

    readonly removeAdInGameLeft: HTMLLinkElement
    readonly removeAdInGameRight: HTMLLinkElement

    constructor() {
        this.containerMainPageRightTop = document.getElementById('main_page_ad_right_top') as HTMLDivElement | null
        this.containerMainPageRightMiddle = document.getElementById('main_page_ad_right_middle') as HTMLDivElement | null
        this.containerMainPageRightBottom = document.getElementById('main_page_ad_right_bottom') as HTMLDivElement | null
        this.containerGameLeft = document.getElementById('in_game_ad_left') as HTMLDivElement
        this.containerGameRight = document.getElementById('in_game_ad_right') as HTMLDivElement
        this.containerGameBottom = document.getElementById('in_game_ad_bottom') as HTMLDivElement
        this.containerGameBottomSmall = document.getElementById('in_game_ad_bottom_small') as HTMLDivElement
        this.modeSelectorAd = document.getElementById('mm-mode-selector-ad') as HTMLDivElement | null

        this.removeAdInGameLeft = document.getElementById('remove_ad_in_game_left') as HTMLLinkElement
        this.removeAdInGameRight = document.getElementById('remove_ad_in_game_right') as HTMLLinkElement
    }
}
